import { HttpSvcFactory } from '../../services/HttpSvc';
import { AuthenticationSvc } from '../../services/AuthenticationSvc';
import { SubscriptionCtrl } from './Subscriptions';
class CouponDirective implements ng.IComponentController {
    private readonly SubscriptionCtrl: SubscriptionCtrl;
    private applyingCoupon: boolean;
    private coupon = this.$state.params.coupon;
    private couponError: string | undefined;
    placeholder = 'Enter your coupon code here';

    constructor(
        private $state: ng.ui.IStateService,
        private HttpSvc: HttpSvcFactory,
        private AuthenticationSvc: AuthenticationSvc
    ) {}

    applyCoupon(coupon: string) {
        this.couponError = undefined;
        this.applyingCoupon = true;
        this.HttpSvc('coupon', coupon)
            .securePost()
            .then((r: any) => r.data)
            .then((response: ApiError) => {
                if (_.isObject(response) && response.code !== 200) {
                    this.couponError = response.message;
                } else {
                    this.coupon = '';
                    this.AuthenticationSvc.notifyUserChange();
                    this.AuthenticationSvc.updateUser().then(() => {
                        this.SubscriptionCtrl.updateSubscriptionDetails();
                        this.SubscriptionCtrl.upgradedTo = response.message;
                        this.SubscriptionCtrl.toggleAppSumoUpgradeResultModal();
                    });
                }
            })
            .finally(() => (this.applyingCoupon = false));
    }
}

angular.module('animatronApp.settings').component('coupon', {
    bindings: { placeholder: '@' },
    require: { SubscriptionCtrl: '^subscription' },
    controller: CouponDirective,
    templateUrl: require('upgrade/coupon.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/couponDirective.ts